module.exports = __webpack_public_path__ + "static/img/203.4a3554d.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/203.png
// module id = 502
// module chunks = 3